<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ex80Sz/tc-custom/9781504087520.jpg?1718106504227" alt="This image is the cover for the book Out of Her Mind"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Out of Her Mind
      </h1>
      <p class="bookDescription body article font2">
        <b>A police detective hunts for the connection between a killer and a nightmare-plagued nurse, in this frightening psychological thriller . . . </b><br/><br/> ICU nurse Sarah Knowles is suffering from nightmares and memory lapses. She finds a vase of roses on her kitchen table but has no recollection of buying them. And why doesn’t she remember moving her belongings around?  <br/><br/> Before she can confide her worries to her friend Anne, Anne goes missing. Meanwhile, DCI Peter Graham is hunting a serial killer known as the Beautician, who is terrorizing the West Yorkshire town of Ledforth. A fingerprint links one of Sarah’s patients at the hospital to the latest murder. What no one realizes is that Sarah has a much more significant connection to the killer—and his preparations for their reunion are almost complete . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sally Hart
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?451074d0